import { PATH_DELIMITER, JOIN_US_PHASE3 } from '../../../constant/Constant';
import { createAction } from 'redux-actions';
import { call, takeEvery } from '@redux-saga/core/effects';
import { request } from '../../ApiModule';
import { MAIN_PATH } from '../../../constant/Constant';

const ACTION_JOIN_US_PHASE3 = JOIN_US_PHASE3 + PATH_DELIMITER + 'ACTION_JOIN_US_PHASE3';

export const actionJoinUsPhase3 = createAction(ACTION_JOIN_US_PHASE3);

export function* joinUsPhase3Sagas() {
    yield takeEvery(ACTION_JOIN_US_PHASE3, joinUsPhase3Saga);
}

function* joinUsPhase3Saga({ payload: { data, callback } }) {
    yield call(request, {
        method: 'post',
        url: '/api/users/student',
        data,
        callback,
    });
}
